import { Dialog as NovaBaseDialog } from '@fme-nova/components'
import { Dialog as MuiBaseDialog, DialogProps, styled } from '@mui/material'

import { createComponentWrapperWithRef } from '../../theme'
import { Z_INDEX } from '../../theme'
import { MsdkStyledComponent } from '../../utils'

const MuiDialog: MsdkStyledComponent<DialogProps> = styled(MuiBaseDialog)`
  z-index: ${Z_INDEX.modal};
  .MuiDialog-paper {
    border-radius: 8px;
    max-width: unset;
  }
`

const NovaDialog: MsdkStyledComponent<DialogProps> = styled(NovaBaseDialog)`
  z-index: ${Z_INDEX.modal};
  .MuiDialog-paper {
    max-width: unset;
  }
`

export const Dialog = createComponentWrapperWithRef<DialogProps>(
  {
    mui: MuiDialog,
    nova: NovaDialog,
  },
  'Dialog',
)
